/* Motion triggers — the ONLY JavaScript on the page. Both effects are the
   reference sites' own CSS; these lines replace just the class-toggling their
   stripped scripts did. Measured on the live sites 2026-08-24. */
(function () {
  /* No prefers-reduced-motion gate: the reference sites animate regardless
     (measured), and the gate made the page read as static on any machine with
     Windows "animation effects" off — a fidelity deviation, dropped 2026-08-24. */
  document.body.classList.add('lq-motion');

  /* Mars Men sticky header: in flow at the top; past its own spot their
     .sticky rule fixes it to the viewport and plays transformFromTop. */
  var hdr = document.querySelector('.ref-mm sticky-header');
  var hdrWrap = hdr && hdr.closest('.ref');
  if (hdr) {
    hdr.classList.remove('sticky');
    var threshold = 0;
    var measure = function () { threshold = hdrWrap.offsetTop + hdrWrap.offsetHeight + 120; };
    measure();
    addEventListener('resize', measure);
    var onScroll = function () { hdr.classList.toggle('sticky', scrollY > threshold); };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mobile menu drawer: their JS is stripped, so the hamburger did nothing
       (base state ships visibility:hidden). Toggle .lq-open — the slide CSS
       sits in the repairs block. Any close control inside the drawer closes. */
    var drawer = hdr.querySelector('header-drawer details');
    if (drawer) {
      var summary = drawer.querySelector('summary');
      var menu = drawer.querySelector('#menu-drawer');
      var setOpen = function (open) {
        drawer.classList.toggle('lq-open', open);
        /* 2026-10-06, his observation: at the very top of the page the open
           drawer left the announcement bar visible and the page could still
           be nudged ("really laggy"); after a scroll it filled the screen.
           Cause: the non-sticky header carries transform:translateY(4px),
           which makes it the containing block of the fixed #menu-drawer, so
           the drawer hung off the header instead of the viewport. While the
           menu is open the header drops that transform (CSS rule in the
           repairs block) and the drawer is viewport-fixed in both states. */
        hdr.classList.toggle('lq-menu-open', open);
        if (open) drawer.setAttribute('open', '');
        document.body.style.overflow = open ? 'hidden' : '';
        if (!open) setTimeout(function () { if (!drawer.classList.contains('lq-open')) drawer.removeAttribute('open'); }, 320);
      };
      if (summary) summary.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(!drawer.classList.contains('lq-open'));
      });
      if (menu) menu.addEventListener('click', function (e) {
        if (e.target.closest('[class*="close"],[aria-label*="Close" i]')) { e.preventDefault(); setOpen(false); return; }
        /* 2026-10-06, his screenshot: "Shop Now" / "Save 38% + Free Shipping"
           / "The Studies" left the drawer OPEN with body scroll locked, so the
           #join_pkg jump never happened (scrollY stayed 0, reproduced live).
           Any link in the drawer now closes it first; an in-page anchor then
           scrolls after the unlock. Off-page links just unlock. */
        var a = e.target.closest('a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        if (href === '#lq-studies') { setOpen(false); return; } /* its own opener (studies drawer script) handles it; no page scroll behind the drawer */
        if (href.charAt(0) === '#' && href.length > 1) {
          e.preventDefault();
          setOpen(false);
          var target = document.getElementById(href.slice(1));
          /* 'instant', verified 2026-10-06: a programmatic smooth scrollIntoView
             did not move this page at all in Chrome (5 s, local and live), while
             a REAL click on a native #join_pkg button does glide. Cause not found;
             instant is the one call that landed every time. */
          if (target) setTimeout(function () {
            target.scrollIntoView({ behavior: 'instant', block: 'start' });
            if (history.replaceState) history.replaceState(null, '', href);
          }, 60);
        } else {
          setOpen(false);
        }
      });
    }
  }

  /* Primal Queen timeline: reveal each row box when reached (their .viewing
     transition), and grow the pink line via --timeline-height-dynamic.
     MEASURED on the live site 2026-08-24: the reveal REPLAYS — scrolling back
     up strips .viewing from boxes below the viewport (2/6 kept after an
     up-scroll, line shrunk to 304px), so each pass down animates again. A
     scroll-driven toggle reproduces that and is immune to fast-scroll skips;
     boxes ABOVE the viewport keep .viewing, matching the live behaviour. */
  var tlBoxes = document.querySelectorAll('.ref-pq .timeline__row_content_box');
  tlBoxes.forEach(function (b) { b.classList.remove('viewing'); });
  var updBoxes = function () {
    tlBoxes.forEach(function (b) {
      b.classList.toggle('viewing', b.getBoundingClientRect().top < innerHeight * 0.85);
    });
  };
  addEventListener('scroll', updBoxes, { passive: true });
  updBoxes();

  var rows = document.querySelectorAll('.ref-pq .timeline__mid_row.timeline__entry_point');
  /* The capture froze --timeline-height at its save-time viewport (1479px =
     desktop), so at other widths the line stops short of the last dot. Their
     JS recomputes it per layout; the frozen desktop value equals exactly the
     first-dot-row -> last-dot-row distance, so derive it from geometry. */
  var updLine = function () {
    rows.forEach(function (row) {
      var r = row.getBoundingClientRect();
      if (r.height === 0) return;
      var mid = row.closest('.timeline__mid') || row.parentElement;
      var all = mid.querySelectorAll('.timeline__mid_row');
      var last = all[all.length - 1];
      var total = last && last !== row ? last.getBoundingClientRect().top - r.top : r.height;
      row.style.setProperty('--timeline-height', total + 'px');
      var progressed = Math.min(total, Math.max(0, innerHeight * 0.75 - r.top));
      row.style.setProperty('--timeline-height-dynamic', progressed + 'px');
    });
  };
  addEventListener('scroll', updLine, { passive: true });
  addEventListener('resize', updLine);
  updLine();
})();


(function(){
  var ts = [].slice.call(document.querySelectorAll('.footer__nav-block-toggle'));
  ts.forEach(function(t){
    var flip = function(){ t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); };
    t.addEventListener('click', flip);
    t.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
  });
})();
(function(){
  var d = document.getElementById('lq-studies-drawer'); if (!d) return;
  var panel = d.querySelector('.lq-sd-panel');
  var setOpen = function(open){
    d.classList.toggle('lq-open', open); d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('lq-sd-locked', open);
    if (open) { var hd = document.querySelector('header-drawer details.lq-open summary'); if (hd) hd.click(); setTimeout(function(){ panel.focus(); }, 50); }
  };
  /* openers: the WHOLE lab-bar box (2026-09-04 — icon included; preventDefault also stops the Light Labs logo link navigating) and every 'The Studies' link (nav + hamburger) */
  var openers = [].slice.call(document.querySelectorAll('.ll-container, a[href="#lq-studies"]'));
  openers.forEach(function(o){ o.addEventListener('click', function(e){ e.preventDefault(); setOpen(true); }); });
  d.addEventListener('click', function(e){
    if (e.target.closest('[data-lq-sd-close]')) { e.preventDefault(); setOpen(false); }
  });
  addEventListener('keydown', function(e){ if (e.key === 'Escape' && d.classList.contains('lq-open')) setOpen(false); });
})();


(function(){
  var g = document.querySelector('[data-lq-gallery]');
  if (!g) return;
  var track = g.querySelector('[data-lq-track]');
  var dots = [].slice.call(g.querySelectorAll('.lq-gal-thumb'));
  var prev = g.querySelector('.lq-gal-prev'), next = g.querySelector('.lq-gal-next');
  var index = function(){ return Math.round(track.scrollLeft / track.clientWidth); };
  var go = function(i){
    var n = Math.max(0, Math.min(dots.length - 1, i));
    track.scrollLeft = n * track.clientWidth;
    sync();
  };
  var sync = function(){
    var i = index();
    dots.forEach(function(d, n){ d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    /* keep the active thumbnail visible in its strip (direct scrollLeft,
       never scrollIntoView - see the smooth-scroll note below). The strip
       is a ROW on a phone and a COLUMN on desktop (Gruns' layout). */
    var a = dots[i]; if (a && a.parentNode) {
      var st = a.parentNode;
      if (getComputedStyle(st).flexDirection === 'column') st.scrollTop = Math.max(0, a.offsetTop - (st.clientHeight - a.offsetHeight) / 2);
      else st.scrollLeft = Math.max(0, a.offsetLeft - (st.clientWidth - a.offsetWidth) / 2);
    }
    if (prev) prev.disabled = i <= 0;
    if (next) next.disabled = i >= dots.length - 1;
  };
  /* thumbs and slides are paired by POSITION (the Supplement Facts slide is
     spliced into both lists at the same place in Liquid) */
  dots.forEach(function(d, n){ d.addEventListener('click', function(){ go(n); }); });
  /* "View Supplement Facts": opens the Supplement Facts panel (his call,
     2026-09-04 second round - "like the studies ... not a new page"). Same
     mechanics as the studies drawer: class toggle, body lock, Escape. */
  var slides = [].slice.call(g.querySelectorAll('.lq-gallery-slide'));
  var factsBtn = document.querySelector('[data-lq-facts-btn]');
  var fd = document.getElementById('lq-facts');
  var setFacts = function(open){
    if (!fd) return;
    fd.classList.toggle('lq-open', open);
    fd.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('lq-sd-locked', open);
    if (open) setTimeout(function(){ var p = fd.querySelector('.lq-fd-panel'); if (p) p.focus(); }, 50);
  };
  if (factsBtn && fd) factsBtn.addEventListener('click', function(){ setFacts(true); });
  else if (factsBtn) factsBtn.hidden = true;
  if (fd) {
    fd.addEventListener('click', function(e){ if (e.target.closest('[data-lq-fd-close]')) { e.preventDefault(); setFacts(false); } });
    addEventListener('keydown', function(e){ if (e.key === 'Escape' && fd.classList.contains('lq-open')) setFacts(false); });
  }
  /* lightbox: a tap on a slide shows it full size (the label has to be readable) */
  var openBox = function(src, alt){
    var box = document.createElement('div'); box.className = 'lq-lightbox'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', alt || 'Image');
    var im = document.createElement('img'); im.src = src; im.alt = alt || '';
    var x = document.createElement('button'); x.type = 'button'; x.className = 'lq-lightbox-x'; x.setAttribute('aria-label', 'Close'); x.textContent = '\u00d7';
    box.appendChild(im); box.appendChild(x);
    var prevOv = document.body.style.overflow;
    var close = function(){ if (box.parentNode) box.parentNode.removeChild(box); document.body.style.overflow = prevOv; removeEventListener('keydown', onKey); };
    var onKey = function(e){ if (e.key === 'Escape') close(); };
    box.addEventListener('click', close); addEventListener('keydown', onKey);
    document.body.appendChild(box); document.body.style.overflow = 'hidden';
  };
  slides.forEach(function(s){ s.addEventListener('click', function(){ openBox(s.getAttribute('data-lq-full') || s.currentSrc || s.src, s.alt); }); });
  if (prev) prev.addEventListener('click', function(){ go(index() - 1); });
  if (next) next.addEventListener('click', function(){ go(index() + 1); });
  ['scroll','scrollend','touchend','pointerup'].forEach(function(ev){
    track.addEventListener(ev, function(){ clearTimeout(g._t); g._t = setTimeout(sync, 80); }, { passive: true });
  });
  /* loading="lazy" is unreliable for slides in a HORIZONTAL scroller: the
     off-screen siblings never enter the viewport vertically, so clicking to
     slide 4 showed an empty pink box with the image still unfetched. Warm
     the whole strip once the buy box is near the viewport — six CDN-resized
     images, so this costs nothing, and the first slide stays eager. */
  var warm = function(){
    [].forEach.call(g.querySelectorAll('.lq-gallery-slide'), function(im){
      if (im.loading === 'lazy') im.loading = 'eager';
    });
  };
  /* NOT IntersectionObserver. Measured on this page 2026-09-03: an observer
     on the gallery never fires, even with the element on screen and an
     800px rootMargin. This page also swallows smooth scrolling and fires no
     scroll events on the track — three browser features broken by the
     lifted markup, so nothing clever is trusted here. Warming after load is
     six CDN-resized images and cannot fail. */
  var warmSoon = function(){ setTimeout(warm, 300); };
  if (document.readyState === 'complete') warmSoon();
  else addEventListener('load', warmSoon);
  addEventListener('resize', sync);
  sync();
})();

(function(){
  var form = document.getElementById('join_pkg');
  if (!form) return;
  var planInput = form.querySelector('[data-lq-selling-plan]');
  form.querySelectorAll('.lq-option input').forEach(function(r){
    r.addEventListener('change', function(){
      form.querySelectorAll('.lq-opt-card').forEach(function(o){
        o.classList.remove('lq-opt-card--selected');
      });
      r.closest('.lq-opt-card').classList.add('lq-opt-card--selected');
      /* PHOENIX: put the subscription selling-plan id here for
         data-lq-plan="subscribe". One-time must stay empty. */
      if (planInput) planInput.value = '';
      form.setAttribute('data-lq-selected', r.getAttribute('data-lq-plan') || '');
      /* 2026-09-10, product-per-offer: the hidden id follows the card */
      var card = r.closest('.lq-opt-card'), vi = form.querySelector('[data-lq-variant-input]');
      if (card && vi && card.getAttribute('var_id')) vi.value = card.getAttribute('var_id');
    });
  });
  var checked = form.querySelector('.lq-option input:checked');
  if (checked) form.setAttribute('data-lq-selected', checked.getAttribute('data-lq-plan') || '');
  if (checked) { var c0 = checked.closest('.lq-opt-card'), vi0 = form.querySelector('[data-lq-variant-input]'); if (c0 && vi0 && c0.getAttribute('var_id')) vi0.value = c0.getAttribute('var_id'); }
})();

(function(){
  var root = document.getElementById('lq-cart');
  if (!root) return;
  var PLANS = {};
  try { PLANS = JSON.parse(root.getAttribute('data-lq-plans') || '{}'); } catch (e) {}
  var $ = function(sel){ return root.querySelector(sel); };
  var money = function(c){ return '$' + (c / 100).toFixed(2); };
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); };
  /* Shopify CDN: a size suffix before the extension gives a resized copy */
  var thumb = function(u){ return u ? u.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_240x$1$2') : ''; };
  var SVG = {
    trash: "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><rect x=\"5\" y=\"3\" width=\"14\" height=\"18\" rx=\"1.5\"/><path d=\"M3 7h18M10 11v6M14 11v6\"/></svg>",
    tag: "<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z\"/><circle cx=\"7.5\" cy=\"7.5\" r=\".5\" fill=\"currentColor\"/></svg>"
  };

  /* ---- price per line: real selling plan wins; else the offer overlay by
     the _plan property; else Shopify's own line price (see the header) ---- */
  var lineView = function(it){
    var plan = (it.properties && it.properties._plan) || 'onetime';
    var p = PLANS[plan] || PLANS.onetime || {};
    var v = { group: p.group || '', line: p.line || '', chip: p.chip || '', sub: plan === 'subscribe' };
    if (it.selling_plan_allocation) {
      v.sub = true;
      v.group = (it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name) || v.group;
      v.price = it.final_line_price;
      var cmp = it.selling_plan_allocation.compare_at_price;
      v.compare = cmp && cmp > it.final_price ? cmp * it.quantity : 0;
    } else if (plan === 'subscribe' && p.price) {
      v.price = p.price * it.quantity;
      v.compare = (p.compare || 0) * it.quantity;
    } else {
      v.price = it.final_line_price;
      v.compare = it.original_line_price > it.final_line_price ? it.original_line_price : 0;
    }
    return v;
  };

  var render = function(cart){
    var items = cart.items || [];
    var count = cart.item_count || 0;
    $('[data-lq-cart-count]').textContent = count;
    var badge = document.querySelector('#cart-icon-bubble .lq-bag-count');
    if (badge) badge.textContent = count;
    /* 2026-10-06, his go: the bag's screen-reader text ("0 items") and Horizon's
       hidden #cart__count never followed the badge. Zero cost: text already on the page. */
    var srCount = document.querySelector('#cart-icon-bubble .cart-count-bubble .visually-hidden');
    if (srCount) srCount.textContent = count + (count === 1 ? ' item' : ' items');
    var hidCount = document.getElementById('cart__count'); if (hidCount) hidCount.textContent = count;
    var empty = count === 0;
    $('[data-lq-cart-empty]').hidden = !empty;
    $('[data-lq-cart-items]').hidden = empty;
    $('[data-lq-cart-ship]').hidden = empty;
    $('[data-lq-cart-banner]').hidden = empty;
    $('[data-lq-cart-summary]').hidden = empty;
    $('[data-lq-cart-foot]').hidden = empty;
    var up = $('[data-lq-cart-up]'); if (up) up.hidden = empty;
    /* 2026-10-06, his screenshot: the "Switch to Subscribe & Save" block stayed
       on screen in an EMPTY cart (it is toggled further down, after this early
       return, so removing the last one-time line never hid it). */
    var upg0 = $('[data-lq-cart-upg]'); if (upg0 && empty) upg0.hidden = true;
    if (empty) return;

    var total = 0, compare = 0, hasSub = false, hasOne = false, html = '', lastGroup = null;
    items.forEach(function(it, i){
      var v = lineView(it);
      if (!v.sub) hasOne = true;
      total += v.price; compare += v.compare || v.price; if (v.sub) hasSub = true;
      if (v.group && v.group !== lastGroup) { html += '<div class="lq-cart-group"><span>' + esc(v.group) + '</span><i></i></div>'; lastGroup = v.group; }
      html += '<article class="lq-cart-item" data-lq-line="' + (i + 1) + '">' +
        '<img class="lq-cart-img" src="' + esc(thumb(it.image)) + '" width="110" height="110" alt="" loading="lazy" decoding="async">' +
        '<div class="lq-cart-info">' +
          '<div class="lq-cart-row1"><h3>' + esc(it.product_title) + '</h3>' +
            '<button type="button" class="lq-cart-del" data-lq-cart-del aria-label="Remove">' + SVG.trash + '</button></div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="lq-cart-l">' + esc(it.variant_title) + '</p>' : '') +
          (v.line ? '<p class="lq-cart-l">' + esc(v.line) + '</p>' : '') +
          '<p class="lq-cart-price"><strong>' + money(v.price) + '</strong>' + (v.compare ? '<s>' + money(v.compare) + '</s>' : '') + (v.sub && it.quantity > 1 ? '<small>x ' + it.quantity + '</small>' : '') + '</p>' +
          (v.chip ? '<span class="lq-cart-chip">' + SVG.tag + esc(v.chip) + '</span>' : '') +
          /* quantity stepper on ONE-TIME lines only (his call 2026-09-05, two rounds: first "why would they buy two monthly" - removed; then "at least for one time purchases" - back for those). Subscription lines keep the trash as their only control; an old sub qty above 1 shows as "x N" beside the price. Compact (32px) so the copy still sits inside the tile. */
          (!v.sub ? '<div class="lq-cart-qty"><button type="button" data-lq-cart-minus aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-lq-cart-plus aria-label="Increase quantity">+</button></div>' : '') +
        '</div></article>';
    });
    $('[data-lq-cart-items]').innerHTML = html;

    /* free-shipping block: the subscription carries free shipping, the
       one-time option does not (the widget's own crosses) - so the bar is
       full with a subscription in the cart and empty without one. COPY IS
       PROVISIONAL on the no-sub state. */
    $('[data-lq-cart-ship-text]').innerHTML = hasSub
      ? "Congrats! You've unlocked <b>FREE SHIPPING!</b>"
      : "Subscribe &amp; Save to unlock <b>FREE SHIPPING</b>";
    $('[data-lq-cart-bar]').style.width = hasSub ? '100%' : '0%';
    /* his calls 2026-09-06: the discount banner only makes sense with a
       subscription in the cart; the upgrade block only with a one-time line */
    $('[data-lq-cart-banner]').hidden = !hasSub;
    var upg = $('[data-lq-cart-upg]'); if (upg) upg.hidden = !hasOne;

    $('[data-lq-cart-sum-sub]').textContent = money(total);
    $('[data-lq-cart-sum-chips]').hidden = !hasSub;
    var ship = $('[data-lq-cart-sum-ship]');
    ship.textContent = hasSub ? 'FREE SHIPPING' : 'Calculated at checkout';
    ship.classList.toggle('lq-free', hasSub);
    $('[data-lq-cart-total]').textContent = money(total);
    var off = compare > total ? Math.round((1 - total / compare) * 100) : 0;
    var pill = $('[data-lq-cart-pill]'), cmpEl = $('[data-lq-cart-compare]');
    pill.hidden = !off; pill.textContent = off + '% Off';
    cmpEl.hidden = !off; cmpEl.textContent = money(compare);
    /* trust row by cart type (his call 2026-09-05): a one-time-only cart has
       nothing to pause and no guarantee, so those two lines go and Primal
       Queen's "Secure & encrypted payments" line takes the second slot */
    var mbg = $('[data-lq-cart-trust-mbg]'); if (mbg) mbg.hidden = !hasSub;
    var tsub = $('[data-lq-cart-trust-sub]'); if (tsub) tsub.hidden = !hasSub;
    var tone = $('[data-lq-cart-trust-one]'); if (tone) tone.hidden = hasSub;
  };

  var busy = false;
  var api = function(url, opts){
    opts = opts || {}; opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function(r){ if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  };
  var refresh = function(){ return api('/cart.js').then(function(c){ render(c); return c; }); };
  var setOpen = function(open){
    root.classList.toggle('lq-open', open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('lq-sd-locked', open);
    if (open) setTimeout(function(){ var p = root.querySelector('.lq-cart-panel'); if (p) p.focus(); }, 50);
  };
  var open = function(){ setOpen(true); return refresh(); };
  var change = function(line, qty){
    if (busy) return; busy = true;
    api('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(render).catch(function(){ return refresh(); }).then(function(){ busy = false; });
  };
  var add = function(body){
    if (busy) return Promise.resolve(); busy = true;
    return api('/cart/add.js', { method: 'POST', body: body })
      .then(function(){ busy = false; return open(); })
      .catch(function(e){ busy = false; throw e; });
  };

  /* the buy form: intercepted so the add stays on the page and the drawer
     opens (it posted to /cart - Horizon's cart page - before). The chosen
     option travels as a hidden line-item property; a failure falls back to
     the native post so a sale is never lost to a script error. */
  var form = document.getElementById('join_pkg');
  if (form) form.addEventListener('submit', function(e){
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('properties[_plan]', form.getAttribute('data-lq-selected') || 'onetime');
    add(fd).catch(function(){ form.submit(); });
  });

  /* the header bag opens the drawer (its href was the buy box anchor) */
  var bag = document.getElementById('cart-icon-bubble');
  if (bag) bag.addEventListener('click', function(e){ e.preventDefault(); open(); });

  root.addEventListener('click', function(e){
    var t = e.target;
    if (t.closest('[data-lq-cart-close]')) {
      var closeA = t.closest('a[href^="#"]');
      e.preventDefault(); setOpen(false);
      /* 2026-10-06: the empty-cart "Shop Now" relied on the anchor's default
         jump; with #join_pkg already in the URL (a second visit to the drawer)
         the browser does nothing, so she sat on a closed drawer at the top of
         the page. Scroll to the buy box explicitly, after the unlock. */
      if (closeA) { var tgt = document.getElementById(closeA.getAttribute('href').slice(1)); if (tgt) setTimeout(function(){ tgt.scrollIntoView({ behavior: 'instant', block: 'start' }); /* instant: a programmatic smooth scroll never moved this page in Chrome (2026-10-06, see the menu handler note in build-1to1.js) */ if (history.replaceState) history.replaceState(null, '', closeA.getAttribute('href')); }, 60); }
      return;
    }
    var item = t.closest('[data-lq-line]');
    if (item) {
      var line = +item.getAttribute('data-lq-line');
      var qtyEl = item.querySelector('.lq-cart-qty span');
      var qty = qtyEl ? +qtyEl.textContent : 1;
      if (t.closest('[data-lq-cart-del]')) change(line, 0);
      else if (t.closest('[data-lq-cart-plus]')) change(line, qty + 1);
      else if (t.closest('[data-lq-cart-minus]')) change(line, Math.max(0, qty - 1));
      return;
    }
    var up = t.closest('[data-lq-cart-add]');
    if (up) { var fd = new FormData(); fd.append('id', up.getAttribute('data-lq-cart-add')); fd.append('quantity', '1'); add(fd).catch(function(){}); return; }
    /* upgrade: every one-time line becomes a subscription line. 2026-09-10,
       product-per-offer: the subscription is ITS OWN VARIANT (PLANS.subscribe.
       variant), so the one-time quantity is re-added as that variant and the
       one-time lines are removed by their line KEY (index-safe: /cart/add.js
       reorders the items array). If no variant is configured, the old
       behaviour stays: the _plan property is rewritten in place, last line
       down so the 1-based indexes survive a merge. */
    if (t.closest('[data-lq-cart-upgrade]')) {
      if (busy) return; busy = true;
      var btn = t.closest('[data-lq-cart-upgrade]'); btn.disabled = true;
      api('/cart.js').then(function(c){
        var subId = PLANS.subscribe && PLANS.subscribe.variant;
        var todo = [];
        (c.items || []).forEach(function(it, i){ if (!lineView(it).sub) todo.push({ line: i + 1, key: it.key, quantity: it.quantity }); });
        if (subId && todo.length) {
          var qty = todo.reduce(function(a, x){ return a + x.quantity; }, 0);
          var fd = new FormData(); fd.append('id', subId); fd.append('quantity', String(qty)); fd.append('properties[_plan]', 'subscribe');
          return api('/cart/add.js', { method: 'POST', body: fd }).then(function(){
            return todo.reduce(function(p, x){
              return p.then(function(){ return api('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: x.key, quantity: 0 }) }); });
            }, Promise.resolve());
          });
        }
        todo.reverse();
        return todo.reduce(function(p, x){
          return p.then(function(){ return api('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: x.line, quantity: x.quantity, properties: { _plan: 'subscribe' } }) }); });
        }, Promise.resolve());
      }).then(function(){ busy = false; btn.disabled = false; return refresh(); })
        .catch(function(){ busy = false; btn.disabled = false; return refresh(); });
      /* keep the widget in step: the subscribe option is the one in the cart now */
      var sub = document.querySelector('#join_pkg input[data-lq-plan="subscribe"]'); if (sub && !sub.checked) { sub.checked = true; sub.dispatchEvent(new Event('change', { bubbles: true })); }
    }
  });
  addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('lq-open')) setOpen(false); });

  /* count on the bag at load; the drawer body is rendered on first open */
  refresh().catch(function(){});
  window.LQCart = { open: open, refresh: refresh, add: add, change: change, close: function(){ setOpen(false); } };
})();